<template id="reset">
    <div>
        <button aria-label="Bouton pour réinitialiser les filtres et la recherche" type="button" class="btn_reset" @click="onClickReset"><span class="glyphicon glyphicon-search"></span><span>Effacer les filtres</span></button>
    </div>
</template>

<script>
    export default{
        name:"Reset",
        components: {
    
        },
        emits: ['reset'],
        props: {
    
        },
        data(){
          return{
    
          }
        }, 
        methods:{
          onClickReset() {
              this.$emit('reset');
          }
        },
        computed: {
    
        }
    }
</script>